import CEPP from "cep-promise";

import { MAPS_API_KEY, URL_GEOCODE } from "@/config/enviroment";

import { logger } from "../logger";

const GEOCODE_URL = `${URL_GEOCODE}/json?key=${MAPS_API_KEY}&address={address}`;

export type Location = {
  latitude: number;
  longitude: number;
};

export const getLocationByAddress = async (address: string): Promise<Location> => {
  const res: any = await new Promise((resolve, reject) => {
    fetch(GEOCODE_URL.replace("{address}", address))
      .then((response) => response.json())
      .then((responseJson) => {
        resolve(responseJson?.results[0]);
      })
      .catch((error) => reject(error));
  });
  return {
    latitude: res?.geometry?.location?.lat,
    longitude: res?.geometry?.location?.lng,
  };
};

export const findAddressByCep = async (cep: string) => {
  try {
    if (!cep) return;
    const res = await CEPP(cep.replace(/-/, ""), {
      timeout: 5000,
      providers: ["brasilapi"] as any,
    });
    return res;
  } catch (error) {
    logger.error(error);
  }
};
